import Keyline from './Keyline';

const ItemDivider: FC = () => <Keyline className="my-3" />;

export default ItemDivider;
